/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.

// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import React from 'react';
import isEqual from 'react-fast-compare';
import _ from 'underscore';

import FinderActions from 'file-browser/FinderActions';
import {Tag} from 'folder-items/FileConstants';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import FormInput from 'ui-library/bs/FormInput';
import Row from 'ui-library/bs/Row';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import PopoverIcon from 'ui-library/PopoverIcon';
import Apiutil from 'util/APIUtil';
import {typeToName} from 'util/NameUtil';

const {apiIdToType} = Apiutil;

interface Props {
  id: string;
  allowEdits: boolean;
  isRegistered: boolean;
  onMountAndUpdate?: () => void;
  tags: Array<Tag>;
}

type State = any;

class TagsSubpanel extends React.Component<Props, State> {
  override state: State = {
    tagName: '',
    tagValue: '',
    updatedTag: null,
  };

  override componentDidMount(): void {
    this.props.onMountAndUpdate?.();
  }

  override componentDidUpdate(): void {
    this.props.onMountAndUpdate?.();
  }

  setTagState = (tag: any): void => {
    this.setState({
      tagName: (tag != null ? tag.name : undefined) || '',
      tagValue: (tag != null ? tag.value : undefined) || '',
    });
  };

  onTagClick = (tag: any): void => {
    // Toggle select.
    this.setTagState(tag.name === this.state.tagName ? null : tag);
  };

  submitTag = (e: any): void => {
    e.preventDefault();
    this._updateModelTags(
      _.object([[this.state.tagName, {value: this.state.tagValue, url: ''}]]),
      [],
      [],
      {}
    );
  };

  removeTag = (tag: any, e: any): void => {
    e.stopPropagation();
    this._updateModelTags({}, [], [tag.name], {});
  };

  override UNSAFE_componentWillReceiveProps(nextProps: Props): void {
    let updatedTag: any = null;
    for (const tag of Array.from(nextProps.tags)) {
      if (!isEqual(tag, _.findWhere(this.props.tags, {name: tag.name}))) {
        updatedTag = tag;
        break;
      }
    }
    if (updatedTag != null) {
      if (updatedTag.name === this.state.tagName) {
        this.setTagState(null);
      }
      // Flash the success color on the updated tag's row.
      this.setState({updatedTag});
      setTimeout(() => {
        if (!isEqual(updatedTag, this.state.updatedTag)) {
          return;
        }
        this.setState({updatedTag: null});
      }, 500);
    }
  }

  _updateModelTags = (toSet: any, toAdd: any, toRemove: any, toRename: any): void => {
    FinderActions.updateTagsWithDataMods(
      [this.props.id],
      this.props.isRegistered,
      {toSet, toAdd, toRemove, toRename},
      {}
    );
  };

  override render(): JSX.Element {
    const existingTag = _.findWhere(this.props.tags, {name: this.state.tagName});
    // Disable submit if tag name is empty or tag name and value are unchanged.
    const submitTagDisabled =
      !this.state.tagName ||
      (((existingTag != null ? existingTag.name : undefined) || '') === this.state.tagName &&
        ((existingTag != null ? existingTag.value : undefined) || '') === this.state.tagValue);
    return (
      <div className="tag-editor">
        {this.props.allowEdits ? (
          <form className="tag-form no-gap" onSubmit={this.submitTag}>
            <Row>
              <Col sm={5}>
                <FormGroup>
                  <FormInput
                    className="tag-name"
                    type="text"
                    placeholder="Tag"
                    value={this.state.tagName}
                    onChange={(e: any) => {
                      this.setState({tagName: e.target.value});
                    }}
                  />
                </FormGroup>
              </Col>
              <Col sm={5}>
                <FormGroup>
                  <FormInput
                    className="tag-value"
                    type="text"
                    placeholder="Value (optional)"
                    value={this.state.tagValue}
                    onChange={(e: any) => {
                      this.setState({tagValue: e.target.value});
                    }}
                  />
                </FormGroup>
              </Col>
              <Col className="add-tag-col" sm={2}>
                <Tooltip
                  title={existingTag != null ? 'Update' : 'Create'}
                  container="body"
                  placement={TooltipPlacement.BOTTOM}
                >
                  <button className="btn btn-af-success" type="submit" disabled={submitTagDisabled}>
                    <BenchlingIcon icon={existingTag != null ? 'refresh' : 'plus-large'} />
                  </button>
                </Tooltip>
              </Col>
            </Row>
          </form>
        ) : undefined}
        <table className="table tag-table">
          <thead>
            <tr>
              <th>
                Tag
                {this.props.allowEdits ? (
                  <a>
                    <PopoverIcon
                      className="u-tiny-spacing-left"
                      title="Using Tags"
                      renderContent={() =>
                        'Add tags such as "phagemid" to organize your data. Values can also be attached to tags such as "AmpR" for "resistance".'
                      }
                      icon="circle-question"
                      placement={FloatingPlacement.LEFT}
                    />
                  </a>
                ) : undefined}
              </th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {this.props.tags.length > 0 ? (
              Array.from(this.props.tags).map((tag) => (
                <tr
                  key={tag.name}
                  className={classNames({
                    active: tag.name === this.state.tagName,
                    success:
                      tag.name === (this.state.updatedTag != null ? this.state.updatedTag.name : undefined),
                  })}
                  onClick={this.onTagClick.bind(this, tag)}
                >
                  <td className="tag-name">
                    <div className="tag-name-wrapper">
                      {tag.name}
                      {this.props.allowEdits ? (
                        <div className="tag-manage-buttons">
                          <span className="tag-delete" onClick={this.removeTag.bind(this, tag)}>
                            ×
                          </span>
                        </div>
                      ) : undefined}
                    </div>
                  </td>
                  <td>{tag.value}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={2}>{`This ${typeToName(apiIdToType(this.props.id))} has no tags.`}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default TagsSubpanel;
